import { useState, useEffect } from 'react';

const useFetchEmployeeApplications = () => {
  const [jobPosts, setJobPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobPosts = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs/applied`, {
          method: 'GET',
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('Failed to fetch job posts');
        }
        const data = await response.json();
  
        const applications = data.data || data || [];
        setJobPosts(applications);
      } catch (error) {
        setError(error.message);
        console.error('Error fetching job posts:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobPosts();
  }, []);

  return { jobPosts, isLoading, error };
};

export default useFetchEmployeeApplications;
